export default __webpack_public_path__ + "static/media/gmail-main.88eb8313.jpg";